<ng-template #pending>
    <app-loading-dots></app-loading-dots>
</ng-template>

<div
    class="reserve-container"
    *ngIf="productDetailService.productDetail$ | async as product"
    [ngClass]="{ loading: pending$ | async }"
>
    <ng-container *ngIf="store.reserveInStore; else notReservable">
        <ng-container *ngIf="(product.storeStocks | storeStock: store) > 0; else noStock">
            <div class="product">
                <app-reserve-in-store-line
                    [data]="reservationProduct$ | async"
                    [pending]="pending$ | async"
                ></app-reserve-in-store-line>
            </div>
            <div class="quantity">
                <app-quantity
                    [max]="product.storeStocks | storeStock: store"
                    [label]="'stock.headings.addItems' | translateSafe"
                    [control]="quantity"
                ></app-quantity>
                <span
                    class="display-caption quantity-reached"
                    *ngIf="quantity.value >= (product.storeStocks | storeStock: store)"
                    >{{ 'stock.maxQuantityReached' | translateSafe }}</span
                >
            </div>
        </ng-container>
        <ng-template #noStock>
            <p class="not-possible">{{ 'stock.storeDoesNotHaveStock' | translateSafe }}</p>
        </ng-template>
    </ng-container>
    <ng-template #notReservable>
        <p class="not-possible">{{ 'stock.notReservable' | translateSafe }}</p>
    </ng-template>

    <h3 class="display-5">{{ 'stock.headings.chosenStore' | translateSafe }}</h3>
    <div class="description">
        <h4 class="display-7">{{ store.storeName }}</h4>
        <span>{{ store.address }}</span>
        <span>{{ store.postalCode }} {{ store.city }}</span>

        <app-store-stock-detailed
            *ngIf="product.storeStocks as stocks"
            [productStocks]="stocks"
            [store]="store"
        ></app-store-stock-detailed>
    </div>

    <button
        *ngIf="store?.storeId | canChangeStoreInReservation: product.variantNo | async"
        (click)="changeStore.emit()"
        class="kk-link kk-link_underline change-store-button"
    >
        {{ 'stock.buttons.changeStore' | translateSafe }}
    </button>

    <div class="buttons">
        <button
            *ngIf="(product.storeStocks | storeStock: store) > 0"
            type="button"
            class="kk-btn add-to-reservation-button"
            [disabled]="
                (pending$ | async) ||
                quantity.value > (product.storeStocks | storeStock: store) ||
                !store.reserveInStore
            "
            (click)="onFinalizeReservation()"
        >
            <ng-container *ngIf="(pending$ | async) === false; else pending">
                {{ 'stock.buttons.finalizeReservation' | translateSafe }}
            </ng-container>
        </button>

        <button
            *ngIf="(product.storeStocks | storeStock: store) > 0"
            type="button"
            [disabled]="
                (pending$ | async) ||
                quantity.value > (product.storeStocks | storeStock: store) ||
                !store.reserveInStore
            "
            (click)="onContinueShopping()"
            class="kk-btn kk-btn_blue continue-button"
        >
            {{ 'stock.buttons.continueShopping' | translateSafe }}
        </button>

        <button
            *ngIf="(product.storeStocks | storeStock: store) === 0"
            type="button"
            class="kk-btn add-to-basket"
            [disabled]="(pending$ | async) || !product.inStock || !store.reserveInStore"
            (click)="onAddToBasket()"
        >
            <ng-container *ngIf="(pending$ | async) === false; else pending">
                {{ 'stock.buttons.putInBasket' | translateSafe }}
            </ng-container>
        </button>

        <button type="button" (click)="closeOverlay.emit()" class="kk-btn kk-btn_secondary cancel-button">
            {{ 'general.action.cancel' | translateSafe }}
        </button>
    </div>
</div>
